/* eslint-disable import/order */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import {
  SmartAccountHeadingText,
  maxTablet,
  maxWidth,
  primaryColor, retina, scrollbar,
} from 'Utils/utilsStyle';
import { AccountPlanForm, AccountPlanSocket, UpdateAccountPlanForm } from 'Types/CompaniesTypes';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/CompaniesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  selectAccountPlanFormFilled, selectAccountSelectedGroups, selectAccountSelectedPeople, selectBuyerPersonId, selectCompetitors, selectDesignationsLoaded, selectDesignationsLoading, selectDocumentSections, selectLoadingLiveIds, selectProductCategory, selectProductDescription, selectSapNotableStaff, selectShowDesignationsLoadingScreen,
  selectAccountPlanCompanyId,
  selectAccountPlanOpen,
} from 'Selector/CompaniesSelector';
import {
  isEnterpriseUser,
  valueToObject,
  getCurrentTime,
  accountPlanSocket,
  getTimezoneInGMT,
  convertToFile,
  getLangCookie,
} from 'Utils/UtilityFunctions';
import {
  selectBatchSize,
  selectBatchUploading,
  selectCurrentFolder,
  selectDrawerOpen, selectEntities, selectEntitiesEnded, selectEntitiesLoaded, selectFailedDocuments, selectFileTypeFlurry, selectFlurryFlag, selectFoldersPopupSelectedFolder, selectIsSelectAll, selectSapRadio, selectSearchTerm, selectSelectedDocuments, selectSelectedDocumentsCount, selectShowSelected, selectSort, selectSortFlurry, selectSortType, selectSuccessDocuments, selectUnselectedDocuments, selectUploadCancelled, selectUploadDocuments, selectUploadDocumentStatus,
} from 'Selector/DocumentHubSelector';
import {
  notification,
} from 'antd';
import { SMART_REDIRECTION_TEXT } from 'Utils/Constants';
import { actions as docActions } from 'Slice/DocumentHubSlice';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { selectAllGroups, selectAllGroupsLoaded, selectAllLoading } from 'Selector/GroupsSelector';
import { selectDisclessPersonality, selectShowDocumentHub } from 'Selector/GlobalSearchContentSelector';

import BuyerGroupModal from 'Components/common/modal/BuyerGroupPeopleModal';
import classNames from 'classnames';
import { useDocumentHubSelection } from 'Utils/hooks/useDocumentHubSelection';
import SmartPlanSliderFooter from './SmartPlanSliderFooter';
import SmartPlanSliderHeaderComponent from './SmartPlanSliderHeaderComponent';
import SmartQuestionAnswerComponent from './SmartQuestionAnswerComponent';
import SmartAccountTabs from './SmartAccountTabs';
import SmartAccountPeopleTab from './SmartAccountPeopleTab';
import SmartAccountBuyerGroupTab from './SmartAccountBuyerGroupTab';
import SmartDesignationLoadingScreen from './SmartDesignationLoadingScreen';
import UploadDocument from './UploadDocument';
import SmartCompanyComparison from './SmartCompanyComparison';
import SmartDocumentSection from './SmartDocumentSection';
import {
  selectActivetype, selectAiCertificationData, selectHighlight,
} from 'Selector/CertificationSelector';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { chatStates } from 'Components/layout/headers/NavBarPrimary';
import { selectCreateNewSap } from 'Selector/UISelector';
import { actions as UiAction } from 'Slice/UISlice';

const Wrapper = styled.div`
height: 100%;
display: flex;
flex-direction: column;
justify-content: space-between;
@media all and (max-width: ${maxTablet}) {
  height: calc(100% - 70px);
}
.overlayForDrawerOnly{
  background-color: rgba(0,0,0,0.5);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  outline: 0;
  z-index: 1000;
}
.slick-slider {
  .slick-list {
    height: calc(100% + 20px);
    .slick-track {
      height: 100%;
      .slick-slide {
        .slider-header {
          background: #DEF6E6;
          padding: 30px 40px 18px;
          height: 184px;
          @media all and (max-width: ${maxWidth}),${retina} {
            height: 140px;
            padding: 24px 40px 11px;
          }
          @media all and (max-width: ${maxTablet}) {
            padding: 20px 10px 28px 10px;
          }
          .slider-heading {
            ${SmartAccountHeadingText};
            font-size: 20px;
            margin-bottom: 0px;
            color: ${primaryColor};
            @media all and (max-width: ${maxWidth}),${retina} {
              font-size: 20px;
            }
            sup {
              font-size: 12px;
              top: -8px;
            }
          }
        }
        .slider-for-smart-components {
          padding: 20px 40px 0px;
          @media all and (max-width: ${maxTablet}) {
            padding: 20px 10px 0px;
          }
          &.slideUploadDocument {
            overflow: hidden !important;
          }
          &.sliderWithoutTabs {
            height: calc(100vh - 262px);
            ${scrollbar};
            @media all and (max-width: ${maxWidth}),${retina} {
              height: calc(100vh - 208px);
            }
            @media all and (max-width: ${maxTablet}) {
              height: calc(100dvh - 276px);
            }
          }
          &.sliderWithTabs {
            height: calc(100vh - 304px);
            padding: 0px;
            @media all and (max-width: ${maxWidth}),${retina} {
              height: calc(100vh - 250px);
            }
            @media all and (max-width: ${maxTablet}) {
              height: calc(100dvh - 322px);
            }
            .smart-account-budget {
              padding: 24px 40px 0px;
              @media all and (max-width: ${maxTablet}) {
                padding: 24px 10px 0px;
              }
            }
          }
          height: calc(100vh - 302px);
          @media all and (max-width: ${maxWidth}),${retina} {
            height: calc(100vh - 246px);
          }
          @media all and (max-width: ${maxTablet}) {
            height: calc(100dvh - 280px);
          }
        }
      }
    }
  }
}
`;
type Props = {
  sliderData: AccountPlanForm[],
  companyName: string,
  selectedCompanyId: number,
  handleNewSapForm: (a?: boolean) => void
};
const SmartAccountPlanSlider = function SmartAccountPlanSlider(props: Props) {
  const { sliderData, companyName, selectedCompanyId, handleNewSapForm } = props;
  const dispatch = useDispatch();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [nextDisable, setNextDisable] = useState(false);
  const [showPopupForSAP, setShowPopupForSAP] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [designationsLoadingwithDelay, setDesignationsLoadingwithDelay] = useState(false);
  const { saveProfileName: saveProfileNameV2 } = chatStates;
  const isEnterprise = isEnterpriseUser();
  const [isNotBuyerCommeittee, setIsNotBuyerCommeittee] = useState(false);
  const [userInput, setUserInput] = useState<UpdateAccountPlanForm[]>([]);
  const [savedProductCategory, setSavedProductCategory] = useState('');
  const [savedProductDescription, setSavedProductDescription] = useState('');
  const [docsLoadedFirstTime, setDocsLoadedFirstTime] = useState(false);
  const sliderRef = useRef<Slider>(null);
  const sliderComponentRef = useRef<Slider>(null);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const formFilled = useSelector(selectAccountPlanFormFilled);
  const productCategory = useSelector(selectProductCategory);
  const productDescription = useSelector(selectProductDescription);
  const designationsLoading = useSelector(selectDesignationsLoading);
  const designationsLoaded = useSelector(selectDesignationsLoaded);
  const allGroups = useSelector(selectAllGroups);
  const allGroupsLoading = useSelector(selectAllLoading);
  const allGroupsLoaded = useSelector(selectAllGroupsLoaded);
  const notableStaff = useSelector(selectSapNotableStaff);
  const selectedPeople = useSelector(selectAccountSelectedPeople);
  const selectedGroups = useSelector(selectAccountSelectedGroups);
  const showDesignationsLoadingScreen = useSelector(selectShowDesignationsLoadingScreen);
  const loadingLiveIds = useSelector(selectLoadingLiveIds);
  const startTime = getCurrentTime();
  const sections = useSelector(selectDocumentSections);
  const competitors = useSelector(selectCompetitors);
  const entities = useSelector(selectEntities);
  const sort = useSelector(selectSort);
  const sortType = useSelector(selectSortType);
  const searchTerm = useSelector(selectSearchTerm);
  const uploadDocuments = useSelector(selectUploadDocuments);
  const failedDocuments = useSelector(selectFailedDocuments);
  const successDocuments = useSelector(selectSuccessDocuments);
  const batchSize = useSelector(selectBatchSize);
  const flurryFlag = useSelector(selectFlurryFlag);
  const flurryArray = useSelector(selectFileTypeFlurry);
  const uploadCancelled = useSelector(selectUploadCancelled);
  const failedDocument = useSelector(selectFailedDocuments);
  const drawerOpen = useSelector(selectDrawerOpen);
  const sortFlurry = useSelector(selectSortFlurry);
  const isSelectAll = useSelector(selectIsSelectAll);
  const selectedDocuments = useSelector(selectSelectedDocuments);
  const unSelectedDocuments = useSelector(selectUnselectedDocuments);
  const host = window.location.href;
  const timezone = getTimezoneInGMT();
  const personId = useSelector(selectBuyerPersonId);
  const batchUploading = useSelector(selectBatchUploading);
  const entitiesLoaded = useSelector(selectEntitiesLoaded);
  const selectedDocumentsCount = useSelector(selectSelectedDocumentsCount);
  const showSelected = useSelector(selectShowSelected);
  const entitiesEnded = useSelector(selectEntitiesEnded);
  const sapDrawerOpen = useSelector(selectAccountPlanOpen);
  const createNewSapGen = useSelector(selectCreateNewSap);
  const [buyerSearchQuery, setBuyerSearchQuery] = useState<string>('');
  const [prevSearchTerm, setPrevSearchTerm] = useState(buyerSearchQuery);
  const { handleCheckAll } = useDocumentHubSelection('sap');
  const accountPlanCompaniesIds = useSelector(selectAccountPlanCompanyId);
  const uploadDocumentStatus = useSelector(selectUploadDocumentStatus);
  const documentHubAllowed = useSelector(selectShowDocumentHub);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const aiCertificationData = useSelector(selectAiCertificationData);
  const isGenereteScreen = currentSlide === sliderData.length - 1 && !showDesignationsLoadingScreen;
  const isSapGenerateHighlighted = sapDrawerOpen && isGenereteScreen && isHighlight && currentType === 'company_profile_sap';
  const selectedFolder = useSelector(selectFoldersPopupSelectedFolder);
  const sapRadio = useSelector(selectSapRadio);
  const currentFolder = useSelector(selectCurrentFolder);

  useEffect(() => {
    if (isGenereteScreen && currentType === 'company_profile_sap' && sapDrawerOpen) {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isGenereteScreen, sapDrawerOpen]);

  useEffect(() => {
    if (currentSlide === 0) {
      const index = userInput?.findIndex((i) => i.id === 1);
      if (index !== -1) {
        if (userInput[index]?.userInput?.toString()?.trim()?.length) {
          setNextDisable(false);
        } else {
          setNextDisable(true);
        }
      } else {
        setNextDisable(true);
      }
    }
  }, [userInput]);
  useEffect(() => {
    const index = userInput?.findIndex((i) => i.id === 1);
    if (index === -1) {
      const inputs = [
        {
          id: 1,
          questionStatement: 'Product Category',
          userInput: productCategory,
        },
        {
          id: 2,
          questionStatement: 'Product Description',
          userInput: productDescription,
        }];
      setUserInput([...userInput, ...inputs]);
    }
  }, [sliderData, userInput]);

  useEffect(() => {
    if (currentSlide === 2 && designationsLoading) {
      setNextDisable(true);
      setDesignationsLoadingwithDelay(true);
    } else if (currentSlide === 2 && !designationsLoading) {
      setNextDisable(false);
      setTimeout(() => {
        setDesignationsLoadingwithDelay(false);
      }, 2000);
    }
  }, [designationsLoading, currentSlide]);

  const connectSockets = (id: number) => {
    console.log('socket connection is establishing');
    accountPlanSocket.connect();
    const onConnect = () => {
      dispatch(actions.getAccountPlanStatus({ accountPlanCompaniesIds: accountPlanCompaniesIds?.join(',') }));
      accountPlanSocket.emit('fe_account_plan', {
        account_plan_id: id,
        username: localStorage.getItem('email'),
        identifier: 'account_plan',
        environment: 'PROD',
      });
    };
    if (accountPlanSocket?.id) {
      onConnect();
    }
    accountPlanSocket.on('connect', onConnect);

    accountPlanSocket.on('disconnect', () => {
      console.log('Disconnected from the server');
    });

    accountPlanSocket.on('error', (error) => {
      console.error('Socket error:', error);
    });
    accountPlanSocket.on('plan_ready', (d: string) => {
      const parseData = JSON.parse(d) as AccountPlanSocket;
      try {
        if (parseData.status === true) {
          const data = {
            // id: 1,
            // name: 'new sap',
            // date: '11/01/2024',
            sapDocumentId: parseData.sapDocumentId,
            companyId: companyIdParsed,
            url: parseData.response,
            previewUrl: parseData.viewableResponse,
          };
          dispatch(actions.setAccountPlan(data));
          dispatch(actions.setSmartAccountToastMessage(
            { message: parseData.message as string, companyId: companyIdParsed },
          ));
          dispatch(actions.removeAccountPlanId(companyIdParsed));
          // accountPlanSocket.disconnect();
          console.log('socket-connection-established', accountPlanSocket.id);
        } else {
          dispatch(actions.setAccountPlanLoading(false));
          dispatch(actions.removeAccountPlanId(companyIdParsed));
          dispatch(actions.setNewAccountPlan());
          dispatch(actions.setGenerationFail());
          dispatch(actions.setAccountPlanFailed(true));
          dispatch(actions.setShowSAPHistory(false));
          dispatch(flurryActions.setNotification({
            message: parseData.message,
            proTip: false,
            rightPlacement: false,
            groupId: 0,
            classnameFlag: false,
            type: 'accountPlan',
            companyId: parseData?.company_id,
          }));
        }
      } catch (error) {
        console.log('error from socket ', error);
      }
    });
  };

  useEffect(() => {
    if (formFilled) {
      const peopleIds = selectedPeople.map((person) => person.personId);
      const groupIds = selectedGroups.map((group) => group.groupId);
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(`accountPlan_clickedNext_personSearch_${selectedPeople.length}`, startTime, {}),
      ));
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(`accountPlan_clickedNext_buyerGroupAdded_${selectedGroups.length}`, startTime, {}),
      ));

      // here set companiesIds for accountplan status api
      dispatch(actions.setCurrentSapCompanyId(companyIdParsed));
      dispatch(actions.generateAccountPlan({
        accountPlanForm: sliderData,
        people: peopleIds,
        groups: groupIds,
        companyId: companyIdParsed,
        ...(selectedCompanyId && selectedCompanyId !== companyIdParsed && { selectedCompanyId }),
        personId,
        connectSockets,
        defaultLanguage: getLangCookie(),
      }));
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('generate_account_plan', startTime, {}),
      ));
      dispatch(certificationActions.aiCertificationAction({
        type: 'generate_sap',
        source: 'sap',
        data: aiCertificationData,
      }));
    }
  }, [formFilled]);

  const updateDesignationsInPayload = () => {
    let counter = 0;
    userInput.forEach((input) => {
      if (input.questionStatement === sliderData[2]?.questions[0]?.statement) {
        const tempInput = input.userInput.slice(0, 50) as string[];
        let totalNumber = tempInput.filter((str) => str.trim() !== '').length;
        const inputLength = input.userInput.length;
        if (input.userInput[inputLength - 1] !== '' && inputLength < 51) {
          totalNumber -= 1;
        }
        dispatch(flurryActions.callFlurryEvent(
          valueToObject(`designationsAdded_${totalNumber}_accountPlan`, startTime, {}),
        ));
        counter += 1;
      }
    });
    if (counter === 0) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('designationsAdded_0_accountPlanaccountplan_clickedNext_0', startTime, {}),
      ));
    }
    dispatch(actions.updateAccountPlanForm(userInput));
  };

  const handleNextSlide = () => {
    if (currentSlide === 0 || currentSlide === 1 || currentSlide === 3 || currentSlide === 4) {
      // if (currentSlide === 1 && disclessPersonality) {
      //   sliderRef?.current?.slickGoTo(3);
      //   sliderComponentRef?.current?.slickGoTo(3);
      // }
      if (currentSlide === 0 && (!documentHubAllowed || !isEnterprise)) {
        sliderRef?.current?.slickGoTo(2);
        sliderComponentRef?.current?.slickGoTo(2);
      } else {
        sliderRef?.current?.slickNext();
        sliderComponentRef?.current?.slickNext();
      }
      dispatch(actions.updateAccountPlanForm(userInput));
      dispatch(actions.setCompaniesIds(companyIdParsed));
    } else if (currentSlide === 2 && showDesignationsLoadingScreen) {
      dispatch(actions.setShowDesignationsLoadingScreen(false));
    } else if (currentSlide === 2) {
      if (disclessPersonality) {
        dispatch(actions.updateAccountPlanForm(userInput));
        sliderRef?.current?.slickNext();
        sliderComponentRef?.current?.slickNext();
        dispatch(actions.updateAccountPlanForm(userInput));
      } else {
        setShowPopupForSAP(true);
      }
    } else {
      let counter = 0;
      userInput.forEach((input) => {
        if (input.questionStatement === sliderData[2]?.questions[0]?.statement) {
          const tempInput = input.userInput.slice(0, 50) as string[];
          let totalNumber = tempInput.filter((str) => str.trim() !== '').length;
          const inputLength = input.userInput.length;
          if (input.userInput[inputLength - 1] !== '' && inputLength < 51) {
            totalNumber -= 1;
          }
          dispatch(flurryActions.callFlurryEvent(
            valueToObject(`designationsAdded_${totalNumber}_accountPlan`, startTime, {}),
          ));
          counter += 1;
        }
      });
      if (counter === 0) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('designationsAdded_0_accountPlanaccountplan_clickedNext_0', startTime, {}),
        ));
      }
      dispatch(actions.updateAccountPlanForm(userInput));
    }
    if (currentSlide === 0 && !designationsLoading && (productDescription !== savedProductDescription || productCategory !== savedProductCategory)) {
      dispatch(actions.setShowDesignationsLoadingScreen(false));
      setSavedProductDescription(productDescription);
      setSavedProductCategory(productCategory);
      dispatch(actions.getRecommendedDesignations({
        companyId: companyIdParsed,
        productCategory,
        companyName,
        productDescription,
        defaultLanguage: getLangCookie(),
      }));
    }
    if (!allGroups.length && !allGroupsLoading && !allGroupsLoaded) {
      dispatch(groupActions.getAllGroups({ offset: 0 }));
    }
    if ((!notableStaff?.length || notableStaff[0]?.companyId !== companyIdParsed) && currentSlide === 0) {
      dispatch(actions.getNotableStaff({
        page: 1,
        companyId: companyIdParsed,
        screenName: 'sap',
      }));
    }
  };

  const handlePrevSlide = () => {
    if (currentSlide === 2 && (!documentHubAllowed || !isEnterprise)) {
      sliderRef?.current?.slickGoTo(0);
      sliderComponentRef?.current?.slickGoTo(0);
    }
    if (currentSlide === 0) {
      handleNewSapForm(true);
      dispatch(docActions.reset());
    } else {
      setNextDisable(false);
      setIsNotBuyerCommeittee(false);
      // if (currentSlide === 3 && disclessPersonality) {
      //   sliderRef?.current?.slickGoTo(1);
      //   sliderComponentRef?.current?.slickGoTo(1);
      // } else {
      // }
      sliderRef?.current?.slickPrev();
      sliderComponentRef?.current?.slickPrev();
    }
  };

  const handleQuestionAns = (input: UpdateAccountPlanForm) => {
    if (input.id === 1 && typeof input.userInput === 'string') {
      dispatch(actions.setProductCategory(input?.userInput as string));
    } else if (input.id === 2 && typeof input.userInput === 'string') {
      dispatch(actions.setProductDescription(input?.userInput as string));
    }
    const index = userInput?.findIndex((i) => i.id === input.id);
    if (index === -1) {
      setUserInput([...userInput, input]);
    } else {
      const updated = [...userInput];
      updated[index] = input;
      setUserInput(updated);
    }
    if (createNewSapGen) {
      dispatch(UiAction.createNewSapFromGenerationScreen(false));
    }
  };

  useEffect(() => {
    const slickDotsList = document.querySelector('ul.slick-dots');

    if (slickDotsList) {
      const listItems = slickDotsList.querySelectorAll('li');

      listItems.forEach((listItem) => {
        const button = listItem.querySelector('button');
        if (button) {
          button.tabIndex = -1;
        }
      });
    }
  }, []);

  const smartComponentSliderControls = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
    touchMove: false,
    swipeToSlide: false,
    swipe: false,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentSlide(newIndex);
      dispatch(actions.setAccountPlanSlideIndex(newIndex));
    },
  };

  useEffect(() => {
    if (allGroups?.length) {
      dispatch(actions.setGroupsToShow(allGroups));
    }
  }, [allGroups]);

  useEffect(() => {
    if (notableStaff?.length) {
      dispatch(actions.setPeopleToShow(notableStaff));
    }
  }, [notableStaff]);

  const fetchMoreDocuments = () => {
    // if (!documentsLoading) {
    //   const updatedSearchList = structureSearchList(searchList);
    //   dispatch(docActions.getDocuments({
    //     offset: showSelected ? sapSelectedDocOffset : documents.length,
    //     isSap: true,
    //     ...showSelected && { showSelected },
    //     sort,
    //     sortType,
    //     timezone,
    //     inSmartDrawer: true,
    //     uploadedByMe: 'false',
    //     ...searchTerm.length && { searchTerm },
    //     isSelectAll,
    //     searchList: updatedSearchList,
    //     selectedDocuments: selectedDocuments?.join(','),
    //     unSelectedDocuments: unSelectedDocuments?.join(','),
    //   }));
    // }
  };

  useEffect(() => {
    if (!entities.length) {
      if (!isEnterprise) {
        // navigate('/');
      } else {
        fetchMoreDocuments();
      }
    }
  }, [sort, sortType, searchTerm, showSelected]);

  const redirectFrom = () => {
    if (saveProfileNameV2 && !saveProfileNameV2.includes(SMART_REDIRECTION_TEXT)) {
      return 'gilroy';
    }
    return 'smartAccountPlan';
  };

  const handleProgress = (progress: any) => {
    dispatch(docActions.setDocumentUploadCount(progress));
  };

  useEffect(() => {
    if (uploadDocumentStatus) {
      const file = uploadDocuments[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          if (flurryFlag) {
            dispatch(flurryActions.callFlurryEvent(
              valueToObject('documentHub_upload_fileSelection_confirmed', startTime, {
                file_type: flurryArray.join(','),
                redirection_from: redirectFrom(),
                host,
              }),
            ));
          }
          const convertedFile = convertToFile(reader.result as string, file.name);
          const fileWithUid = Object.assign(convertedFile, {
            uid: file.uid,
          });
          dispatch(docActions.uploadDocument({
            file: fileWithUid,
            timezone,
            inSmartDrawer: true,
            handleProgress,
            folderId: selectedFolder?.id || currentFolder?.id || 0,
          }));
          dispatch(docActions.setUploadDocumentStatus({ filenameAllowed: false }));
        };
      }
    }
  }, [uploadDocumentStatus, uploadDocuments, failedDocuments]);

  useEffect(() => {
    if (uploadDocuments.length && (successDocuments.length
      + uploadDocuments.length + failedDocuments.length === batchSize)) {
      const file = uploadDocuments[0];
      dispatch(docActions.validateFileName({
        name: file.name,
        folderId: selectedFolder?.id || currentFolder?.id || 0,
        timezone,
      }));
    }
  }, [uploadDocuments, failedDocuments]);

  useEffect(() => {
    if (!sapDrawerOpen || !sliderData[1]?.questions?.[0]) {
      return;
    }

    dispatch(actions.updateSAPDocSelection({
      isSap: true,
      isSelectAll,
      uploadedByMe: 'false',
      searchTerm,
      selectedDocuments: selectedDocuments.filter((d) => d.type === 'document').map((d) => d.id).join(','),
      unSelectedDocuments: unSelectedDocuments?.filter((d) => d.type === 'document').map((d) => d.id).join(','),
      selectedFolders: selectedDocuments.filter((d) => d.type === 'folder').map((d) => d.id).join(','),
      unSelectedFolders: unSelectedDocuments.filter((d) => d.type === 'folder').map((d) => d.id).join(','),
      gilroyItems: sapRadio === 'document'
    }));
  }, [sapDrawerOpen, selectedDocumentsCount, sliderData]);

  useEffect(() => {
    if (!uploadDocuments.length && successDocuments.length && !uploadCancelled) {
      dispatch(flurryActions.setNotification({
        message: successDocuments.length === batchSize ? 'Files uploaded successfully' : `${successDocuments.length}/${batchSize} files uploaded successfully`,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
      if (successDocuments.some((successDoc) => successDoc.isLink === true)) {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_link_upload_successful', 0, {
          file_type: successDocuments.map((fileType) => fileType.extension).join(',').toString(),
          redirection_from: redirectFrom(),
          host,
        })));
      } else {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_uploadDocument_successful', 0, {
          file_type: successDocuments.map((fileType) => fileType.extension).join(',').toString(),
          redirection_from: redirectFrom(),
          host,
        })));
      }
    }
    if (!uploadDocuments.length && failedDocument.length && !uploadCancelled) {
      if (failedDocument.some((successDoc) => successDoc.isLink === true)) {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_link_upload_failure', 0, {
          file_type: failedDocument.map((fileType) => fileType.type).join(',').toString(),
          redirection_from: redirectFrom(),
          host,
        })));
      } else {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_uploadDocument_failure', 0, {
          file_type: failedDocument.map((fileType) => fileType.type).join(',').toString(),
          redirection_from: redirectFrom(),
          host,
        })));
      }
    }
  }, [uploadDocuments]);

  useEffect(() => {
    if (!batchUploading && uploadCancelled) {
      notification.destroy();
      successDocuments.forEach((doc) => {
        dispatch(docActions.deleteDocument({
          selectedDocuments: doc.id?.toString(),
          unSelectedDocuments: '',
          isSelectAll: false,
          uploadedByMe: 'false',
        }));
      });
      dispatch(docActions.resetBatch());
      dispatch(docActions.resetUploadCancel());
    }
  }, [batchUploading, uploadCancelled]);

  useEffect(() => {
    if (sortFlurry) {
      dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_sorting_updated', 0, {
        sorting_type: sortFlurry,
        host,
      })));
    }
  }, [sortFlurry]);


  const goToNextSlide = () => {
    sliderRef?.current?.slickNext();
    sliderComponentRef?.current?.slickNext();
    setShowPopupForSAP(false);
  };

  useEffect(() => {
    if (entitiesLoaded && !docsLoadedFirstTime && sapRadio === 'document' && !currentFolder) {
      handleCheckAll(true);
      setDocsLoadedFirstTime(true);
    }
  }, [entitiesLoaded, docsLoadedFirstTime]);

  useEffect(() => {
    if (!entities.length || !entitiesLoaded) {
      setDocsLoadedFirstTime(false);
    }
  }, [entities])

  const getSelectedDocs = () => {
    dispatch(docActions.setSapSelectedDocOffset(0));
    dispatch(docActions.setShowSelected(true));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('sap_filesSelectedCount_clicked', startTime, {}),
    ));
  };

  useEffect(() => {
    if (!entitiesEnded && entities.length < 9 && entitiesLoaded) {
      fetchMoreDocuments();
    }
  }, [entities]);

  return (
    <Wrapper className="smart-account-plan-slider">
      <Slider
        {...smartComponentSliderControls}
        ref={sliderComponentRef}
      >
        {sliderData.map((slide, index) => (
          <>
            <div className="slider-header">
              <h1 className="slider-heading">
                Smart Account Plan
                <sup>TM</sup>
              </h1>
              {(index === 1 && (!documentHubAllowed || !isEnterprise)) ? null : (
                <SmartPlanSliderHeaderComponent
                  hideDocHub={!documentHubAllowed || !isEnterprise}
                  index={index}
                  sliderData={sliderData}
                  title={slide?.heading}
                  paragraph={slide?.summary}
                />
              )}
            </div>
            <div className={classNames('slider-for-smart-components', {
              sliderWithTabs: currentSlide === 2 && !showDesignationsLoadingScreen,
              sliderWithoutTabs: showDesignationsLoadingScreen || (currentSlide !== 2),
              slideUploadDocument: currentSlide === 1,
            })}
            >
              {currentSlide === 2 && !showDesignationsLoadingScreen ? (
                <SmartAccountTabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setIsNotBuyerCommeittee={setIsNotBuyerCommeittee}
                />
              ) : null}
              {index === 0 ? (
                <div>
                  {slide?.questions?.map((question, i) => <SmartQuestionAnswerComponent handleQuestionAns={handleQuestionAns} questionData={question} textAreaRows={i === 0 ? 1 : 10} isActive questionIndex={i + 1} />)}
                </div>
              ) : null}
              {index === 1 && documentHubAllowed && isEnterprise ? (
                <UploadDocument question={slide?.questions[0]} />
              ) : null}
              {index === 2 ? (showDesignationsLoadingScreen ? <SmartDesignationLoadingScreen designationsLoading={designationsLoadingwithDelay} />
                : (
                  <>
                    <SmartQuestionAnswerComponent
                      handleQuestionAns={handleQuestionAns}
                      questionData={slide?.questions[0]}
                      multiInputs
                      currentSlide={currentSlide}
                      isNotBuyerCommeittee={isNotBuyerCommeittee}
                      isDesignationsAPI={designationsLoaded}
                      setIsNotBuyerCommeittee={setIsNotBuyerCommeittee}
                      isActive={activeTab === 0}
                    />
                    <SmartAccountPeopleTab companyStaff={notableStaff} isActive={activeTab === 1} />
                    <SmartAccountBuyerGroupTab allGroups={allGroups} isActive={activeTab === 2} />
                  </>
                )
              ) : null}
              {
                index === 3 ? (
                  <SmartCompanyComparison
                    summary={slide.questions[0]?.statement}
                    tooltipText={slide.questions[0]?.tooltip}
                    exampleText={slide.questions[0]?.example}
                    companies={slide.questions[0]?.competitors ?? []}
                  />
                ) : null
              }
              {
                index === 4 ? (
                  <SmartDocumentSection
                    sections={slide.questions[0]?.sections ?? []}
                    summary={slide.questions[0]?.statement}
                    tooltipText={slide.questions[0]?.tooltip}
                    exampleText={slide.questions[0]?.example}
                  />

                ) : null
              }
            </div>
          </>
        ))}
      </Slider>
      <BuyerGroupModal
        sapBuyerAnalysis
        showPopupForSAP={showPopupForSAP}
        setShowPopupForSAP={() => setShowPopupForSAP(false)}
        goToNextSlide={goToNextSlide}
        buyerSearchQuery={buyerSearchQuery}
        setBuyerSearchQuery={setBuyerSearchQuery}
        prevSearchTerm={prevSearchTerm}
        setPrevSearchTerm={setPrevSearchTerm}
        updateDesignationsInSap={updateDesignationsInPayload}
      />
      <SmartPlanSliderFooter
        showSelectedDocs={currentSlide === 1}
        isBackDisable={false}
        isNextDisable={nextDisable || (!selectedDocumentsCount && currentSlide === 1) || (designationsLoadingwithDelay && currentSlide === 2) || (loadingLiveIds?.length > 0 && currentSlide === 2) || (currentSlide === 3 && competitors?.length !== 3) || (currentSlide === 4 && !!sections?.every((s) => !s.selected))}
        nextBtnText={isGenereteScreen ? 'Generate' : 'Next'}
        onBack={handlePrevSlide}
        onNext={handleNextSlide}
        getSelectedDocs={getSelectedDocs}
        highlightedComponent={isSapGenerateHighlighted}
      />
      {isSapGenerateHighlighted && <div className="overlayForDrawerOnly" />}
    </Wrapper>
  );
};
export default SmartAccountPlanSlider;
